// extracted by mini-css-extract-plugin
export default {"report":"SalesByVendor_report__ks8-y","report-header":"SalesByVendor_report-header__ndrO2"};